import { useStaticQuery } from '../../../helpers/useStaticData';
import { getFoodTypesResponse } from '../../../helpers/data';

export const useGetFoodTypesQuery = () => useStaticQuery(() => getFoodTypesResponse());
